import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { HiOutlineMenuAlt3, HiOutlineX } from 'react-icons/hi';
import logo from "../assets/main-logo.png";

const navItems = [
  { label: 'About', to: '/about' },
  { label: 'Merch', to: '/merch' },
  { label: 'Music', to: '/music' },
  { label: 'Videos', to: '/videos' },
  { label: 'Tour', to: '/tour' },
  { label: 'Subscribe', to: '/subscribe' },
  { label: 'Contact', to: '/contact' },
];

const SiteHeader = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-40 bg-gradient-to-b from-slate-950/90 via-slate-950/30 to-transparent backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 transition-all">
        <NavLink to="/" className="group flex items-center gap-3">
          <span className="flex h-12 w-12 items-center justify-center">
            <img src={logo} alt="Logo" className="h-8 w-8" />
          </span>
          <div className="leading-tight">
            <p className="font-heading text-lg font-semibold uppercase tracking-widest text-white drop-shadow-lg">
              Tolu John
            </p>
            <p className="text-xs uppercase tracking-[0.4em] text-white/60">Music Artist</p>
          </div>
        </NavLink>

        <nav className="hidden items-center gap-8 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  'font-medium uppercase tracking-[0.35em] text-xs transition-colors',
                  isActive ? 'text-accent-200 drop-shadow-md' : 'text-white/70 hover:text-white',
                ]
                  .filter(Boolean)
                  .join(' ')
              }
            >
              {item.label}
            </NavLink>
          ))}
          <NavLink
            to="/tour"
            className="rounded-full border border-white/30 px-4 py-2 text-xs font-semibold uppercase tracking-[0.4em] text-white transition hover:border-accent-300/80 hover:text-accent-100"
          >
            Tour Dates
          </NavLink>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-white/30 bg-white/5 text-white transition hover:border-white md:hidden"
          aria-label="Toggle navigation"
        >
          {open ? <HiOutlineX className="h-6 w-6" /> : <HiOutlineMenuAlt3 className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-slate-950/95 backdrop-blur md:hidden">
          <nav className="mx-6 flex flex-col gap-4 py-6 text-sm uppercase tracking-[0.4em] text-white/70">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  [
                    'rounded-full px-4 py-2 text-center',
                    isActive ? 'bg-white/10 text-white' : 'hover:bg-white/5 hover:text-white',
                  ].join(' ')
                }
              >
                {item.label}
              </NavLink>
            ))}
            <NavLink
              to="/tour"
              onClick={() => setOpen(false)}
              className="rounded-full border border-white/20 px-4 py-2 text-center font-semibold text-white"
            >
              Tour Dates
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
};

export default SiteHeader;

